import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import axios from 'axios'
import config from '../config'

import { fetchUserData } from '../actions/user'

export default (WrappedComponent) => {
    class withAuthorize extends Component {
        componentDidMount(){
            this.props.fetchUserData(true)
        }

        redirectIfUnauthorize = () => {
            delete axios.defaults.headers.common.authorization
            let loginURL = "/login"
            return (
                <Redirect
                to={{
                    pathname: loginURL,
                    state: { from: this.props.location },
                }}
                />
            )
        }
        renderComponent(){
            const { auth, user, match, location, history } = this.props
            const token = auth.access_token
            if (auth.access_token) {
                axios.defaults.headers.common.authorization = "Bearer "+ token
                return <WrappedComponent { ...this.props }/>
            }else{
               return this.redirectIfUnauthorize()
            }
        }
        render() {
            return (
                <Fragment>
                    {this.renderComponent()}
                </Fragment>
            ) 
        }
    }

    const mapStateToProps = (state) => {
        return{
            auth: state.auth,
            user: state.user,
        }
    }
    const mapDispatchToProps = {
        fetchUserData
    }

    return connect(mapStateToProps,mapDispatchToProps)(withAuthorize)
}